import React from 'react';
import { IconProps } from '.';

const SvgColoredGraphDown = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <g clipPath='url(#ColoredGraphDown_svg__a)'>
        <path
          fill='#FACAC7'
          d='M1.333 4A2.667 2.667 0 0 1 4 1.333h16A2.667 2.667 0 0 1 22.667 4v16A2.667 2.667 0 0 1 20 22.667H4A2.667 2.667 0 0 1 1.333 20V4Z'
        />
        <path
          fill='#F05046'
          fillRule='evenodd'
          d='M3.583 3.984a.8.8 0 0 0-.266 1.1l7.334 12a.8.8 0 0 0 1.29.103l3.297-3.847 4.087 6.423a.8.8 0 1 0 1.35-.86l-4.667-7.333a.8.8 0 0 0-1.282-.09l-3.284 3.83-6.76-11.06a.8.8 0 0 0-1.1-.266Z'
          clipRule='evenodd'
        />
      </g>
      <defs>
        <clipPath id='ColoredGraphDown_svg__a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgColoredGraphDown;
